import axios from 'axios';

/*

export default axios.create({
  baseURL: 'http://localhost:3001',
  responseType: 'json',
});*/


// ⬇️ put your current ngrok https URL here
const NGROK = 'https://discussed-watches-kevin-anime.trycloudflare.com';

// If you’re running the UI from localhost, talk to localhost;
// otherwise talk to ngrok.
const BASE =
  (typeof window !== 'undefined' && window.location.hostname === 'localhost')
    ? 'http://localhost:3001'
    : NGROK;

export default axios.create({
  baseURL: BASE,
  responseType: 'json',
});

